import { render } from "./HtmlBehaviourSelector.vue?vue&type=template&id=f3a00656"
import script from "./HtmlBehaviourSelector.vue?vue&type=script&lang=js"
export * from "./HtmlBehaviourSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__